module.exports = __webpack_public_path__ + "static/media/bg.e592c8d6.png";